var content = require("!!../../../../node_modules/postcss-loader/src/index.js??embedded!../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./LoadingSpinner.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
